module.exports = __webpack_public_path__ + "/a6edfaa77d7ca18c123000c270a37dfd.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/cloud_icon_bw.svg
 ** module id = 1627
 ** module chunks = 0
 **/